module.exports = __webpack_public_path__ + "static/media/no-connection.51023630.svg";